import { useState, type ChangeEvent } from 'react'

import { Button, Divider, TextArea } from '@/shared'
import { type ISectionRulesWrapper, type IRuleSection } from '@App/types/servicesTypes'

import style from './ChosenRule.module.scss'

interface IProps extends IRuleSection {
    isFetching: boolean
    sectionRules: ISectionRulesWrapper
    setChosen: (chosen: IRuleSection | null) => void
    onChangeRules: (dto: ISectionRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const ChosenRule = (props: IProps) => {
    const {
        title: initTitle,
        description: initDescription,
        isFetching,
        sectionRules,
        setChosen,
        onChangeRules,
        id
    } = props
    const [title, setTitle] = useState<string>(initTitle)
    const [description, setDescription] = useState<string>(initDescription)
    const onChangeTitle = (e: ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)
    const onChangeDescriptions = (e: ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)

    const onChangeRule = () => {
        const dto: ISectionRulesWrapper = {
            id: sectionRules.id,
            sections: sectionRules.sections.map((section) =>
                section.id === id ? { ...section, title, description } : section
            )
        }
        const onSuccess = () => {
            setChosen(null)
        }
        onChangeRules(dto, onSuccess, false)
    }

    const onRemoveRule = () => {
        const dto: ISectionRulesWrapper = {
            id: sectionRules.id,
            sections: sectionRules.sections.filter((section) => section.id !== id)
        }
        const onSuccess = () => {
            setChosen(null)
        }
        onChangeRules(dto, onSuccess, false)
    }

    return (
        <div className={style.container}>
            <div className={style.fields}>
                <input value={title} onChange={onChangeTitle} placeholder='Укажите заголовок правила' />
                <TextArea value={description} onChange={onChangeDescriptions} placeholder='Укажите описание правила' />
            </div>
            <div className={style.divider}>
                <Divider />
            </div>
            <div className={style.wrapper}>
                <div className={style.btnWrapper}>
                    <Button onClick={onChangeRule} disabled={isFetching}>
                        Изменить
                    </Button>
                </div>
                <div className={style.btnWrapper}>
                    <Button onClick={onRemoveRule} disabled={isFetching}>
                        Удалить
                    </Button>
                </div>
            </div>
        </div>
    )
}
